import React from 'react';
import styled from '@emotion/styled';
import { mix } from 'polished';
import { useComponentTheme } from '../useComponentTheme';

type Props = {
  className: ?string,
  children: React.Node,
};

export const SwitchGroup = ({ className, children }: Props) => {
  const componentTheme = useComponentTheme(theme => theme.components.SwitchGroup);

  return (
    <Wrapper className={className} componentTheme={componentTheme}>
      {children}
    </Wrapper>
  );
};

const Wrapper = styled('div')`
  display: flex;
  color: ${({ theme }) => theme.color.grey};
  font-size: ${({ theme }) => theme.fontSize.md};
  width: 100%;

  label {
    width: 100%;
    border: ${({ theme }) => theme.stroke.light};
    padding: 10px 16px;
    background-color: ${({ theme }) => theme.color.white};

    &:first-of-type {
      border-top-left-radius: ${({ theme }) => theme.borderRadius.medium};
      border-bottom-left-radius: ${({ theme }) => theme.borderRadius.medium};
    }

    &:last-of-type {
      border-bottom-right-radius: ${({ theme }) => theme.borderRadius.medium};
      border-top-right-radius: ${({ theme }) => theme.borderRadius.medium};
    }

    @media (${({ theme }) => theme.breakpoint.kiosk}) {
      padding: 12px 16px;
    }
  }

  input:checked + label {
    border-color: ${({ theme, componentTheme }) => componentTheme?.selectedColor || theme.color.brand};
    color: ${({ theme, componentTheme }) => componentTheme?.selectedColor || theme.color.brand};
    background-color: ${({ theme, componentTheme }) =>
      mix(0.15, componentTheme?.selectedColor || theme.color.brand, theme.color.white)};
    font-weight: ${({ theme }) => theme.fontWeight.bold};
  }

  &:hover {
    svg {
      fill: ${({ theme, componentTheme }) => componentTheme?.selectedColor || theme.color.brand};
    }
  }
`;

SwitchGroup.defaultProps = {
  className: null,
};
